$(function () {

  var DOORS = DOORS || {};
  DOORS.PAGE = {};

  DOORS.PAGE.validation = {
    init: function () {
      this.setParameters();
      this.bindEvent();
    },
    setParameters: function () {
      this.$form = $('.jsc-form');
      this.$emailInput = $('input[type="email"]');
      this.$passwordInput = $('input[type="password"]');
      this.$submitButton = $('.jsc-submit');
    },
    bindEvent: function () {
      const myself = this;
      this.$emailInput.blur(function () {
        if ($(this).val() === '' || !$(this).val().match(/[^\s\t]/) || !$(this).val().match(/^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i)) {
          if (!$(this).next('span.error-message').length) {
            $(this).after('<span class="error-message">※メールアドレスを入力してください</span>');
            $(this).addClass('error-input');
          }
        } else {
          if ($(this).nextAll('span.error-message').length) {
            $(this).next('span.error-message').remove();
            $(this).removeClass('error-input');
          }
        }
        myself.check();
      });
      this.$passwordInput.blur(function () {
        if ($('input[type="password"]').val() === '' || !$('input[type="password"]').val().match(/^[0-9a-zA-Z]*$/)) {
          if (!$('input[type="password"]').next('span.error-message').length) {
            $('input[type="password"]').after('<span class="error-message">※パスワードを入力してください</span>');
            $('input[type="password"]').addClass('error-input');
          }
        } else {
          if ($('input[type="password"]').nextAll('span.error-message').length) {
            $('input[type="password"]').next('span.error-message').remove();
            $('input[type="password"]').removeClass('error-input');
          }
        }
        myself.check();
      });
    },
    check: function () {
      if ($('input[type="email"]').nextAll('span.error-message').length > 0 || $('input[type="password"]').nextAll('span.error-message').length > 0) {
        this.$submitButton.prop('disabled', true);
      } else {
        this.$submitButton.prop("disabled", false);
      }
    }
  }

  DOORS.PAGE.CheckUserExistsForLogIn = {
    init: function () {
      this.setParameters();
      this.setSession();
      this.getSessionAndPreviousPage();
    },
    setParameters: function () {
      this.$submitButton = $('.jsc-submit');
      this.$errorContainer = $('.jsc-login-error');
    },
    getSessionAndPreviousPage: function () {
      const hasLoggedIn = sessionStorage.getItem('hasLoggedIn');
      const previousPage = document.referrer;
      if (previousPage.indexOf('challenge') != -1 && hasLoggedIn == 'true') {
        this.showError();
      }
      sessionStorage.removeItem('hasLoggedIn');
    },
    setSession: function () {
      const myself = this;
      this.$submitButton.on('click', function () {
        sessionStorage.setItem('hasLoggedIn', 'true');
      })
    },
    showError: function () {

      this.$errorContainer.show();
    }
  }

  DOORS.PAGE.validation.init();
  DOORS.PAGE.CheckUserExistsForLogIn.init()
});